module.exports = __webpack_public_path__ + "static/media/Illus-Outpost_2@3x.62a85322.png";